import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://6cb56372f14a75d94d1a1f76f4c05307@o4509395812941824.ingest.us.sentry.io/4509395823820800",
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      colorScheme: "system",
    }),
  ],
});

import Providers from "./Providers";
import { ProtectedRoute } from "./components/auth";
import {
  NurseryList,
  NurseryDetail,
  TankDetail,
  TankSearch,
  RackDetail,
  RackObservationCreation,
  RackObservationUpdate,
} from "./pages";
import { RequestQueueHandler } from "./components";
import { ChangePassword } from "./pages/users";
import NotFound from "./pages/NotFound";
import { Count } from "./pages/count";

function App () {
  return (
    <Providers>
      <RequestQueueHandler />
      <Router>
        <Routes>
          <Route path="/" element={<ProtectedRoute />}>
            <Route path="/" element={<NurseryList />} />
            <Route path="/nurseries/:nurseryId/" element={<NurseryDetail />} />
            <Route path="/nurseries/:nurseryId/tanks/search/" element={<TankSearch />} />
            <Route path="/nurseries/:nurseryId/tanks/:tankId/" element={<TankDetail />} />
            <Route path="/nurseries/:nurseryId/tanks/:tankId/racks/:rackId/" element={<RackDetail />} />
            <Route path="/nurseries/:nurseryId/tanks/:tankId/racks/:rackId/observation" element={<RackObservationCreation />} />
            <Route path="/nurseries/:nurseryId/tanks/:tankId/observation" element={<RackObservationCreation />} />
            <Route path="/nurseries/:nurseryId/observation" element={<RackObservationCreation />} />
            <Route path="/nurseries/:nurseryId/tanks/:tankId/racks/:rackId/observation/:observationId" element={<RackObservationUpdate />} />
            <Route path="/user/password/" element={<ChangePassword />} />
            <Route path="/count/" element={<Count />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Providers>
  );
}

export default App;
